module.exports = __webpack_public_path__ + "img/award-3.1560efff.png";